import type { IntradayBatchMetadata } from "model/state"

export interface IntradayDrilldownFields {
  intradayAsOf: string | null
  batchId: string | null
}

/**
 * Resolves the frozen intraday fields a drilldown intent needs from the dashboard's intraday state.
 * Batch instruments carry the as-of on the batch; live-pricing analytics carry it on
 * intradayPricingAsOf. The two are mutually exclusive, so fall back across both. Centralised here
 * (rather than copy-pasted into each graph/factors-view trigger) so the precedence has one home.
 */
export function resolveIntradayDrilldownFields(
  isIntradayMode: boolean,
  intradayBatchMetadata: IntradayBatchMetadata | null | undefined,
  intradayPricingAsOf: string | null | undefined,
): IntradayDrilldownFields {
  if (!isIntradayMode) {
    return { intradayAsOf: null, batchId: null }
  }
  return {
    intradayAsOf: intradayBatchMetadata?.asOf ?? intradayPricingAsOf ?? null,
    batchId: intradayBatchMetadata?.id ?? null,
  }
}
